import React, { useCallback, useEffect, useMemo, useState,useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { LobIconUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { ModalNextContext, Icon, Loader } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { ServiceManager } from '@jutro/legacy/services';
import { IntlContext, Grid, useTranslator } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import moment from 'moment';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import metadata from './BillingSummaryPage.metadata.json5';
import styles from './BillingSummaryPage.module.scss';
import messages from './BillingSummaryPage.messages';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics';
import { AccountDropDownValues, ProducerContext } from '../../cpmi_SelectAccountDropDown';

const getTabHeader = (productCode, label = '') => {
    const icon = LobIconUtil.getMaterialIcon(productCode);
    return (
        <div id={`divFor${productCode}${label}`} className={styles.tabContent}>
            {productCode ? (
                <Icon
                    id={`iconFor${productCode}${label}`}
                    icon={icon}
                    title={label}
                />
            ) : null}
            <span id={`labelFor${productCode}${label}`}>
                {label.toUpperCase()}
            </span>
        </div>
    );
};

function BillingSummaryPage(props) {
    const { match, authHeader, history } = props;
    const { params } = match;
    const { streamId } = params;
    const translator = useTranslator();
    const {showAlert}=useContext(ModalNextContext);
    const {setMultiInvoiceDropDown}=useContext(ProducerContext);
    const [isLoading, setLoadingState] = useState(false);
    const localeService = ServiceManager.getService('locale-service');
    const defaultCurrencyCode = localeService
        .getDefaultCurrencyCode()
        .toUpperCase();

    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );

    const { PolicyService } = useDependencies('PolicyService');

    // screen states
    const [isLoadingData, updateIsLoadingData] = useState(true);
    const [selectedInvoiceStreamId, updateSelectedInvoiceStreamId] = useState(
        streamId
    );
    const [selectedCurrency, updateSelectedCurrency] = useState(
        defaultCurrencyCode
    );
    const [activeTab, updateActiveTab] = useState(selectedInvoiceStreamId);
    const [BillingData,setBillingData]=useState();
    const[userData,setUserData]=useState()
    const [trackPageView, trackEvent] = usecpmiAnalytics();
    const[billingDropdownValue,setBillingDropdownValue]=useState();
    const [ribbonFlag,setRibbonFlag]=useState(false);
    const [ribbonCount,setRibbonCount]=useState(0);
    // fetched data
    const [
        accountBillingSummaryFromApi,
        setAccountBillingSummaryFromApi,
    ] = useState({});
    const [
        invoiceStreamDetailsMapFromApi,
        setInvoiceStreamDetailsMapFromApi,
    ] = useState(new Map());
    const [policySummariesFromApi, setPolicySummariesFromApi] = useState([]);

    const {
        accountLevelBilling = false,
        invoiceStreams = [],
    } = accountBillingSummaryFromApi;
    const [multiInvoiceStreamData, setMultiInvoiceStreamData] = useState(props?.history?.location?.state?.multiStreamDropDownArray);
    const [multiInvoiceSelectedValue,setMultiInvoiceSelectedValue] = useState(props?.history?.location?.state?.invoiceStreamID);
    const [invoiceBillingDataset,setInvoiceBillingDataset] = useState([]);
    const [multiInvoceStreamDueAmount,setMultiInvoceStreamDueAmount] = useState();
    const [multiInvoceStreamCurrentDueArray,setMultiInvoceStreamCurrentDueArray] = useState([]);
    const [accountsData,setUserAccountsData] = useState([]);
    // const [multiInvoiceSTreamPublicId, setMultiInvoiceSTreamPublicId] = useState();
    const [count,setCount] = useState()
    const updateMap = useCallback(
        (invoiceStreamId) => (fetchData) => {
         
            setInvoiceStreamDetailsMapFromApi(
                invoiceStreamDetailsMapFromApi.set(invoiceStreamId, fetchData)
            );
            setBillingData(fetchData);
            const { totalValue } = fetchData.invoiceStreamDetails;
            const { currency } = totalValue;
            updateSelectedCurrency(currency.toUpperCase());
        },
        [invoiceStreamDetailsMapFromApi]
    );
    

    const fetchAccountLevelInvoiceStreams = useCallback(() => {
        let accountInvoicePromise;
        let policySummaryPromise;

        if (_.isEmpty(accountBillingSummaryFromApi)) {
            accountInvoicePromise = BillingService.getAccountInvoiceStreamInformation(
                authHeader
            ).then((accountInvoiceStreams) => {
                // accountInvoiceStreams= {
                //     "accountLevelBilling": false,
                //     "invoiceStreams": []
                // }
                const {
                    accountLevelBilling: accountLevelBillingFromApi = false,
                    invoiceStreams: invoiceStreamsFromApi = [],
                } = accountInvoiceStreams;

                let defaultInvoiceStreamId;
                if (invoiceStreamsFromApi.length > 0) {
                    defaultInvoiceStreamId =
                        invoiceStreamsFromApi[0].internalId;
                }
                if (
                    accountLevelBillingFromApi &&
                    invoiceStreamsFromApi.length === 1
                ) {
                    defaultInvoiceStreamId =
                        invoiceStreamsFromApi[0].internalId;
                    updateSelectedInvoiceStreamId(
                        invoiceStreamsFromApi[0].internalId
                    );
                    updateActiveTab(invoiceStreamsFromApi[0].internalId);
                }

                setAccountBillingSummaryFromApi(accountInvoiceStreams);
                return defaultInvoiceStreamId;
            });
        } else {
            accountInvoicePromise = Promise.resolve(
                accountBillingSummaryFromApi
            );
        }

        if (policySummariesFromApi.length === 0) {
            policySummaryPromise = PolicyService.getAccountPolicySummaries(
                authHeader
            ).then(setPolicySummariesFromApi);
        } else {
            policySummaryPromise = Promise.resolve(policySummariesFromApi);
        }
            const promiseData =  EnrollmentService.getUser(props.userInfo.email, authHeader)
                    .then((userAccountDataSet) => {
                        setUserAccountsData(userAccountDataSet)
                })

        const accountInfoPromise = UsersProfileDetailsService.getAccountsContactSummaries(authHeader
        ).then(setUserData);

        return Promise.all([accountInvoicePromise, policySummaryPromise,accountInfoPromise,promiseData]).catch(
            () => {
                showAlert({
                    title: messages.failedToLoadPolices,
                    message:
                        messages.sorryWeCanNotLoadYourPolicyInformationAtThisTime,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).then(() => {
                    history.push('/home');
                }, _.noop);
            }
        );
    }, [accountBillingSummaryFromApi, policySummariesFromApi, BillingService, authHeader, PolicyService, showAlert, history]);

    const getPaymentDetailsGroupFromMap = useCallback(
        (invoiceStreamId) => {
            return invoiceStreamDetailsMapFromApi.get(invoiceStreamId);
        },
        [invoiceStreamDetailsMapFromApi]
    );
    
    const fetchInvoiceDetailsByStreamId = useCallback( 
        async(invoiceStreamId, forceRefresh = false) => {
            invoiceStreamId=1
            const invoiceDetails = getPaymentDetailsGroupFromMap(
                invoiceStreamId
            );
            let invoiceDetailsPromise;
    
            if (
                ((invoiceStreamId && _.isEmpty(invoiceDetails ) ||
                forceRefresh)) && billingDropdownValue!==undefined
                
            ) {
                updateIsLoadingData(true);
                invoiceDetailsPromise = await BillingService.getSelectedAccountBillingSummary_Ext(billingDropdownValue,
                    authHeader
                )
                
                    .then((res)=>{
                        updateIsLoadingData(false);
                        setRibbonCount(ribbonCount+1);
                        setBillingData('')
                        setBillingData(res);
                        setInvoiceBillingDataset(res);
                        updateMap(invoiceStreamId)
                        const invoiceSTreamsArray = [];
                        const invoicesLength=res.allInvoiceStreamDetails?.length;
                        let tempCount=0;
                        if(accountsData !== undefined){ 
                            // eslint-disable-next-line array-callback-return
                            accountsData.roles.map((loopItm)=>{
                                // eslint-disable-next-line array-callback-return
                                res.allInvoiceStreamDetails.map((subItem)=>{
                                    if(subItem.internalId === loopItm.invoiceId){
                                        tempCount+=1;
                                        invoiceSTreamsArray.push(
                                            {
                                                name:subItem.displayName,
                                                code:subItem.internalId
                                            })
                                    }
                                }) 
                                
                            })
                        }
                        
                        if(invoicesLength>=tempCount){
                            setCount(true)            
                        }
                        else{
                            setCount(false)
                        } 
                        if(props?.history?.location?.state?.invoiceStreamID !== undefined){
                            setMultiInvoiceSelectedValue(props?.history?.location?.state?.invoiceStreamID);
                        }else if((!invoicesLength>tempCount ||invoicesLength===tempCount)){                                                       
                            if (invoiceSTreamsArray.length === 1) {
                                setCount(false);
                                setMultiInvoiceSelectedValue(invoiceSTreamsArray[0].code);
                                setMultiInvoiceDropDown(invoiceSTreamsArray[0].code);
                            }
                            else {
                                setMultiInvoiceSelectedValue(undefined);
                            }                            
                        }                        
                        setMultiInvoiceStreamData(invoiceSTreamsArray);
                        
                    }  
                    )
                    .catch(() => {
                        showAlert({
                            title: messages.failedToLoadPolices,
                            message:
                                messages.sorryWeCanNotLoadYourPolicyInformationAtThisTime,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok,
                        }).then(() => {
                            history.push('/home');
                        }, _.noop);
                    });
            } else {
                invoiceDetailsPromise = Promise.resolve(invoiceDetails);
            }
            return invoiceDetailsPromise;
        },
        [getPaymentDetailsGroupFromMap, BillingService, authHeader, updateMap, showAlert, history,billingDropdownValue]
    );

    useEffect(()=>{
        fetchInvoiceDetailsByStreamId();
    },[fetchInvoiceDetailsByStreamId])
    
    const multiInvoiceChange = useCallback((value)=>{       
        setMultiInvoiceSelectedValue(value);
        history.replace({ state: {
            multiInvoiceSelectedValue:value
        } });
        // eslint-disable-next-line array-callback-return 
        invoiceBillingDataset.allInvoiceStreamDetails?.map((itemInvoice)=>{
            if(itemInvoice.internalId === value){
                const dueAmountVl = itemInvoice.invoiceSummary.map((item) => item.invoiceStatus === 'due' && item.amountDue.amount).reduce((prev, next) => prev + next);
                
                setMultiInvoceStreamDueAmount(dueAmountVl);
               // BillingData.multiInvoceStreamDueAmount = dueAmountVl;
                const topfourCurrentDueArray = [];
                // eslint-disable-next-line array-callback-return
                itemInvoice.invoiceSummary.map((invoicesmryItem)=>{
                    if(invoicesmryItem.invoiceStatus==="billed" && topfourCurrentDueArray.length<4){
                        topfourCurrentDueArray.push(invoicesmryItem);
                    }
                })

                
                setMultiInvoceStreamCurrentDueArray(topfourCurrentDueArray);
            }
        })
    },[BillingData,invoiceBillingDataset, multiInvoceStreamDueAmount,billingDropdownValue])

    const multiInvoiceOnload = useCallback((value)=>{
        setMultiInvoiceSelectedValue(value);
       
        // eslint-disable-next-line array-callback-return 
        invoiceBillingDataset.allInvoiceStreamDetails?.map((itemInvoice)=>{
            if(itemInvoice.internalId === value){
                const dueAmountVl = itemInvoice.invoiceSummary.map((item) => item.invoiceStatus === 'due' && item.amountDue.amount).reduce((prev, next) => prev + next);
                
                setMultiInvoceStreamDueAmount(dueAmountVl);
               // BillingData.multiInvoceStreamDueAmount = dueAmountVl;
                const topfourCurrentDueArray = [];
                // eslint-disable-next-line array-callback-return
                itemInvoice.invoiceSummary.map((invoicesmryItem)=>{
                    if(invoicesmryItem.invoiceStatus==="billed" && topfourCurrentDueArray.length<4){
                        topfourCurrentDueArray.push(invoicesmryItem);
                    }
                })

                
                setMultiInvoceStreamCurrentDueArray(topfourCurrentDueArray);
            }
        })
    },[BillingData,invoiceBillingDataset, multiInvoceStreamDueAmount,billingDropdownValue])

    

    const selectedLobCode = useMemo(() => {
        const foundInvoiceStreams = invoiceStreams.filter(
            (item) => item.internalId === selectedInvoiceStreamId
        );
        return foundInvoiceStreams.length > 0
            ? foundInvoiceStreams[0].lobcode
            : undefined;
    }, [invoiceStreams, selectedInvoiceStreamId]);

    const onTabClick = useCallback(
        (invoiceStreamIdFromTabId) => {
            fetchInvoiceDetailsByStreamId(invoiceStreamIdFromTabId).finally(
                () => {
                    updateActiveTab(invoiceStreamIdFromTabId);
                    updateSelectedInvoiceStreamId(invoiceStreamIdFromTabId);
                }
            );
        },
        [fetchInvoiceDetailsByStreamId]
    );
   

   

    useEffect(()=>{

    },[invoiceBillingDataset, multiInvoiceChange, multiInvoiceSelectedValue, multiInvoiceStreamData])

    


    useEffect(()=>{
        if(multiInvoiceSelectedValue!==undefined){
            multiInvoiceOnload(multiInvoiceSelectedValue);
        }
    },[invoiceBillingDataset, multiInvoiceOnload, multiInvoiceSelectedValue, multiInvoiceStreamData])

    const reloadInvoiceDetails = useCallback(
        (invoiceStreamId) => {
            updateIsLoadingData(true);
            return fetchInvoiceDetailsByStreamId(invoiceStreamId, true).finally(
                () => {
                    updateIsLoadingData(false);
                }
            );
        },
        [fetchInvoiceDetailsByStreamId]
    );

    useEffect(() => {
        updateIsLoadingData(true);
        fetchAccountLevelInvoiceStreams().then((retValues) => {
            if (retValues) {
                const initStreamId = selectedInvoiceStreamId || retValues[0];
                fetchInvoiceDetailsByStreamId(initStreamId).finally(() => {
                    //onTabClick(initStreamId);
                    setRibbonCount(ribbonCount+1);
                    updateIsLoadingData(false);
                    
                });
            }
        });
        // execure once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
   

    useEffect(() => {
        trackPageView("View Billing Summary","/billing-summary")
    },[])
    
    const noData = useCallback(() => {
        // return invoiceStreams.length === 0;
        return _.isEmpty(BillingData);
    }, [BillingData]);

    

    

    const deliquentAlert = useCallback(()=>{
        if(!_.isEmpty(BillingData) )
        {    
            const CurrentDue= (moment(_.get(BillingData, 'basicDetails.currentDueDate')).format('MM/DD/YYYY'));
            const Today=(moment(LocalDateUtil.today()).format('MM/DD/YYYY'));        
            const isDueToday = (CurrentDue === Today);
            const dueAmount = BillingData.basicDetails.currentDue.amount>0;
            const pastDueAmount=BillingData.basicDetails.pastDue.amount;
            if(isDueToday && dueAmount && pastDueAmount===0)
            {           
                return true
            }
            // const delinquent = BillingData.basicDetails.isDelinquent
            // if(isDueToday && dueAmount && !delinquent)
            // {           
            //     return true
            // }
        }         
        return false 
    },[BillingData])
    
    const getReferenceNumber = useCallback(()=>{
        if(props.history.location.state!==null && props.history.location.state !== undefined && props.history.location.state.PaymentCanceled!=='PaymentCanceled')
            return( props.history.location.state.res) ;  
        return ' ';
    },[props.history.location.state])

    const getInfoVisiblity=useCallback(()=>{
        
        if(props.history.location.state!==null && props.history.location.state !== undefined  &&props.history.location.state.PaymentCanceled!=='PaymentCanceled'&&props.history.location.state.message==="approved")
        {
            return true
        }
        return false

    },[props])

    const handleValueChange = (value) => {
        if(props?.history?.location?.state?.invoiceStreamID === undefined){
            setMultiInvoiceSelectedValue('')
        }
        setBillingDropdownValue(value);
        if(value===undefined || (billingDropdownValue!==undefined && value!==billingDropdownValue)){
            history.replace({ state: {} });
        }
    }
    const getInvoiceDropValue = useCallback((value)=>{
        if(props?.history?.location?.state?.invoiceStreamID === undefined){
            setMultiInvoiceSelectedValue(value);
        }
    },[])

    if (isLoadingData) {
        return <LoaderExt loaded={!isLoadingData} />;
    }
    
    const overrideProps = {
        ACHPaymentSuccessInfo:{
            // visible:getInfoVisiblity(),
            visible:props.history.location.state!==null && props.history.location.state !== undefined && props.history.location.state.PaymentCanceled!=='PaymentCanceled' && props.history.location.state.message==="approved" && props.history.location.state.accountNumber===billingDropdownValue,
            message:translator(messages.ACHInfo,{referncenumber:getReferenceNumber()})
        },
        alertBanner: {
            visible: deliquentAlert(),
            message: translator(messages.alertBanner, {
                CurrentDue: (moment(_.get(BillingData, 'basicDetails.currentDueDate')).format('MM/DD/YYYY'))
            })
        },
        noDataMessageContainer: {
            visible: noData() && ribbonCount>=2 ,
            message: messages.noBillingData,
        },
        billingSummaryContainer: {
            visible: !noData(),
        },
        pageHeaderId:{
            visible: !noData(),
        },
        billingTabsId: {
            accountLevelBilling,
            history,
            invoiceStreamId: selectedInvoiceStreamId,
            lobCode: selectedLobCode,
            paymentGroupDetails:BillingData, 
            accountNumber:billingDropdownValue,
            currency: selectedCurrency,
            multiInvoceStreamCurrentDueArray:multiInvoceStreamCurrentDueArray,
            policySummaries: policySummariesFromApi,
            multiInvoiceSelectedValue:multiInvoiceSelectedValue,
            multiInvoceStreamDueAmount:multiInvoceStreamDueAmount,
            multiInvoiceStreamData,
            invoiceBillingDataset,
            BillingData,
            accountsData,
            // multiInvoiceSelectedValue,
            reloadInvoiceDetails: reloadInvoiceDetails,
            // content: (() => {
            //     return [{
            //        // id: item.internalId,
            //         type: 'element',
            //         component: 'div',
            //         componentProps: {
            //           //  heading: getTabHeader(item.lobcode, item.label),
            //         },
            //         content: [
            //             {
            //                // id: `billingContentFor${item.internalId}`,
            //                 type: 'container',
            //                 component: 'BillingSummary',
            //                 componentProps: {
            //                     accountLevelBilling,
            //                     history,
            //                     invoiceStreamId: selectedInvoiceStreamId,
            //                     lobCode: selectedLobCode,
            //                     paymentGroupDetails: getPaymentDetailsGroupFromMap(
            //                         selectedInvoiceStreamId
            //                     ),
            //                     accountNumber:userData[0].accountNumber,
            //                     currency: selectedCurrency,
            //                     policySummaries: policySummariesFromApi,
            //                     reloadInvoiceDetails: reloadInvoiceDetails,
            //                 },
            //             },
            //         ],
            //     }];
            // }),
            activeTab: activeTab,
            onTabChange: onTabClick,
            multiInvoiceChange:multiInvoiceChange
        },
        availableProducerCode:{
            message:props.history?.location?.state?.message,
            accNumCreditCard:props.history?.location?.state?.accountNumber,
            multiInvoiceStreamValue:multiInvoiceSelectedValue,
            getInvoiceDropValue:getInvoiceDropValue,
            pageBilling:"Billing"
        },
        multiInvoiceStreamDropdown:{
            availableValues:multiInvoiceStreamData,
            visible:count && invoiceBillingDataset.allInvoiceStreamDetails.length > 1,
            onValueChange:(value,index)=>{
                multiInvoiceChange(value);
                setMultiInvoiceDropDown(value)
            },
            value:multiInvoiceSelectedValue,
            alwaysShowPlaceholder:!count
        },
        summarySection:{
            visible: (multiInvoiceSelectedValue === '' || multiInvoiceSelectedValue === undefined?false:true) ,
            className:multiInvoiceStreamData?.length===1?"pageNew":"page"
        },
        invoiceStreamText:{
            visible:count && invoiceBillingDataset.allInvoiceStreamDetails.length > 1,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap:{
            handleValueChange,
            getInvoiceDropValue
        },
        resolveComponentMap:{
            AccountDropDownValues: AccountDropDownValues,
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrideProps} {...resolvers} />
}

BillingSummaryPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            streamId: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};

export default withAuthenticationContext(withRouter(BillingSummaryPage));
